document.addEventListener("DOMContentLoaded", () => {
  const mainHero_glide = new Glide(".ep__main-hero-glide", {
    perView: 1,
  });
  mainHero_glide.on("mount.after", function () {
    document
      .querySelectorAll(".ep__main-hero-glide-controls > button.left")
      .forEach((leftButton) => {
        leftButton.addEventListener("click", () => {
          document
            .querySelector(
              ".ep__main-hero-glide-hidden-controls .glide__arrow--left"
            )
            .click();
        });
      });
    document
      .querySelectorAll(".ep__main-hero-glide-controls > button.right")
      .forEach((rightButton) => {
        rightButton.addEventListener("click", () => {
          document
            .querySelector(
              ".ep__main-hero-glide-hidden-controls .glide__arrow--right"
            )
            .click();
        });
      });
  });
  mainHero_glide.mount();
});
